// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__1naDI","title":"Images90_title__1o-QV","images":"Images90_images__quwOs"};